import { Box, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material'
import React from 'react'

import { GrayTypography } from 'views/Authorized/views/ProductDetails/styles'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'
import useSearchFiltersQuery from 'shared/store/useSearchFilters'
import CustomDialog from 'shared/components/CustomDialog'

interface Props {
   open: boolean
   onClose: () => void
   categoryUuid: string
   details: { [key: string]: string }
}

export default function ProductDetailsModal({ open, onClose, categoryUuid, details }: Props) {
   const { data } = useSearchFiltersQuery(categoryUuid, {
      selectedFilters: {},
      selectedProducerUuids: [],
      filterKeys: null,
   })

   return (
      <CustomDialog
         isLoading={false}
         open={open}
         onClose={onClose}
         content={
            <>
               <DialogTitle>Szczegóły produktu</DialogTitle>
               <DialogContent>
                  {details &&
                     Object.entries(details).map(([key, value]) => (
                        <>
                           <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                              <GrayTypography>
                                 {data?.filters.find((filter) => filter.uuid === key)?.name}:
                              </GrayTypography>
                              <Typography>{value}</Typography>
                           </Box>
                           <Divider />
                        </>
                     ))}
               </DialogContent>
               <DialogActions>
                  <OutlinedButton onClick={onClose}>Zamknij</OutlinedButton>
               </DialogActions>
            </>
         }
      />
   )
}
